const logger = console
const worker = {
  validate() {
    return ('serviceWorker' in navigator)
  },
  register() {
    const swOptions = { scope: '/' }
    const success = (reg) => {
      logger.info('Service Worker Registered.\n', reg)
    }
    const error = (err) => {
      logger.info('Service Worker Registration Failed.\n', err)
    }

    const valid = this.validate()

    if (!valid) {
      return error(valid)
    }

    return navigator.serviceWorker
      .register('/service-worker.js', swOptions)
      .then(success)
      .catch(error)
  },
}

export default worker
